import type { RetirementCalculatorOutputs } from '@fruitful/financial-calculators';
import { formatDollars } from '@fruitful/fruitils';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { H5Emphasized, YStack } from 'smoothie';

import { Button } from '../../common/components/GroveButtons';

interface RetirementContributionsSimulationTableProps {
    outputs: RetirementCalculatorOutputs;
    onSelectAmount: (amount: number) => void;
}

export const RetirementContributionsSimulationTable = ({
    outputs,
    onSelectAmount,
}: RetirementContributionsSimulationTableProps) => {
    return (
        <YStack gap={12} width="90vw" maxWidth={800}>
            <H5Emphasized>
                Annual Retirement Contributions Simulations
            </H5Emphasized>
            <DataTable
                value={Object.entries(outputs.annualSavingsOutcomes).map(
                    ([amount, outcome]) => ({
                        amount: Number(amount),
                        successLikelihood: outcome.successLikelihood,
                        outcome,
                    }),
                )}
                size="small"
                tableStyle={{ width: '100%' }}
                sortField="amount"
                sortOrder={1}
                scrollable
                scrollHeight="60vh"
            >
                <Column
                    field="amount"
                    header="Annual Savings Amount"
                    sortable
                    body={(rowData: {
                        amount: number;
                        successLikelihood: number;
                        outcome: { successLikelihood: number };
                    }) => formatDollars(rowData.amount)}
                />
                <Column
                    field="successLikelihood"
                    header="Success Likelihood"
                    sortable
                    body={(rowData: {
                        amount: number;
                        successLikelihood: number;
                        outcome: { successLikelihood: number };
                    }) => `${(rowData.successLikelihood * 100).toFixed(1)}%`}
                />
                <Column
                    header="Actions"
                    body={(rowData: {
                        amount: number;
                        successLikelihood: number;
                        outcome: { successLikelihood: number };
                    }) => (
                        <Button
                            variant="secondary"
                            size="small"
                            onPress={() => {
                                onSelectAmount(rowData.amount);
                            }}
                        >
                            Select
                        </Button>
                    )}
                />
            </DataTable>
        </YStack>
    );
};
